import React, { useState, useEffect } from "react";
import "./footer.css";
import { eventClick } from "../services/adobeDataLayer.js";

function Footer() {

  const [showButton, setShowButton] = useState(false);
  const [nearBottom, setNearBottom] = useState(false);
  useEffect(() => {
    const handlePosition = () => {
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const screenWidth = window.innerWidth;
      setShowButton(scrollY > 150);
      const bottomOffset = screenWidth >= 767 ? 60 : 40;

      if (scrollY + windowHeight >= documentHeight - bottomOffset) {
        setNearBottom(true);
      } else {
        setNearBottom(false);
      }
    };
    handlePosition();

    window.addEventListener("scroll", handlePosition);
    window.addEventListener("resize", handlePosition);

    return () => {
      window.removeEventListener("scroll", handlePosition);
      window.removeEventListener("resize", handlePosition);
    };
  }, []);

  const handleCTAClick = (e) => {
    e.preventDefault();
    eventClick("apply now", "button", "footer");
    window.dispatchEvent(new CustomEvent("adobeCTAClick"));
    const formElement = document.getElementById('myForm');
    if (formElement) {
      formElement.scrollIntoView({ behavior: 'smooth' });
      setTimeout(() => {
        const firstNameField = document.getElementById('firstName');
        if (firstNameField) {
          firstNameField.focus();
        }
      }, 300);
    }
  };

  return (
    <>
      <footer>
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <p>
                <sup>#</sup>Subject to eligibility
                <br>
                </br>*Terms and Conditions of ICICI Bank apply. For details visit <a href="https://www.icici.bank.in/" rel='noreferrer'
                  target="_blank">www.icici.bank.in</a></p>
            </div>
            <div className="col-md-6">
              <div>
                <p className="text-right">Corporate Office Address: ICICI Bank Towers, Bandra-Kurla Complex, Mumbai 400 051.</p>
              </div>
            </div>
          </div>
        </div>
      </footer>
      {showButton && (
        <div
          className="footerapplynow"
        >
          <a href="#myForm" onClick={handleCTAClick} className={`sticky_apply_now ${nearBottom ? "near-footer" : ""
            }`}>
            Apply now
          </a>
        </div>
      )}

    </>
  );
}

export default Footer;
